import BaseService from '@/services/BaseService';
export const CLS_FACILITY_TERMS_COLLECTION = 'ClsFacilityTermsEntity';

const CLS_DEAL_NAMES_PATH = 'cls/facility-terms/deal-names';
const CLS_USED_AMOUNT_BY_DATE_PATH = 'cls/facility-terms/used-amount-by-date';

export type ClsUsedAmountByDateRow = {
  asOfDate: string;
  usedAmountUsdSum: number;
};

export type ClsSsrmDatasourceConfig = {
  endpoint: 'SSRM';
  collection: typeof CLS_FACILITY_TERMS_COLLECTION;
};

export type ClsUsedAmountSeriesParams = {
  dealName: string;
  startDate: string;
  endDate: string;
};

/** Row shape matches SSRM JSON (camelCase from API). */
export interface ClsFacilityTermsRow {
  croLinkId?: number | string | null;
  asOfDate?: string | null;
  dealName?: string | null;
  trancheName?: string | null;
  committedAmount?: number | null;
  usedAmountUsd?: number | null;
  usedMargin?: number | null;
  creditSpreadAdjRate?: number | null;
  unusedRate?: number | null;
  dueAndPayableDate?: string | null;
  revolvingPeriodEnd?: string | null;
  lenderOfRecord?: string | null;
  csId?: string | null;
  stratFinDesk?: string | null;
}

/** HTTP client for CLS facility terms deal names, chart series, and SSRM grid config. */
export class ClsDashboardService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  resolveClsSsrmConfig = (): ClsSsrmDatasourceConfig => ({
    endpoint: 'SSRM',
    collection: CLS_FACILITY_TERMS_COLLECTION,
  });

  fetchDealNames = async (max = 50_000): Promise<string[]> => {
    const response = await this.get({ path: CLS_DEAL_NAMES_PATH, params: { max } });
    return Array.isArray(response) ? response : [];
  };

  fetchUsedAmountSeries = async (params: ClsUsedAmountSeriesParams): Promise<ClsUsedAmountByDateRow[]> => {
    const response = await this.get({
      path: CLS_USED_AMOUNT_BY_DATE_PATH,
      params: {
        dealName: params.dealName,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
    return Array.isArray(response) ? response : [];
  };
}
